
import * as _csRCL from './_csRcl';
import * as _ht from './_ht';

const _mdlz = _csRCL.grtAtom("mdlz", {
  abtz: {},
  bShow: false,
  bCls: true,
  mdlClds: [],
  onCls: undefined,
});

export const useMdlz = () => {
  const _dz = _csRCL.grtStt(_mdlz);
  const _show = (pz: _ht.dz) => {
    _dz.set({
      ... pz,
      bShow: true,
    })
  };
  const _hide = () => {
    _dz.set({
      bShow: false,
    })
  };
  return {
    ... _dz,
    hide: _hide,
    show: _show,
  };
};

